"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageMeter = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../utils/CardHelper");
const ProgressBar_1 = require("./ProgressBar");
function UsageMeter(applicationType, usage, limit, warning) {
    const innerContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        style: adaptivecards_1.ContainerStyle.Default,
    });
    const usageTextRow = new adaptivecards_1.ColumnSet();
    innerContainer.addItem(usageTextRow);
    const usageIconColumn = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        width: "auto",
        verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
    });
    usageIconColumn.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: (0, CardHelper_1.getImageCardUrl)("RESPONSES_ICON", applicationType),
        style: adaptivecards_1.ImageStyle.Person,
    }));
    usageTextRow.addColumn(usageIconColumn);
    const usageTextColumn = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        spacing: adaptivecards_1.Spacing.Small,
        verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
    });
    usageTextColumn.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `${usage}/${limit} Responses collected`,
    }));
    usageTextRow.addColumn(usageTextColumn);
    innerContainer.addItem((0, ProgressBar_1.ProgressBar)(applicationType, Math.min(usage / limit, 1) * 100, warning));
    return innerContainer;
}
exports.UsageMeter = UsageMeter;
//# sourceMappingURL=UsageMeter.js.map